import type { SVGProps } from 'react';
const SvgPeopleAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#people_alt_svg__a)">
      <path
        fillRule="evenodd"
        d="M16.67 13.13C18.04 14.06 19 15.32 19 17v3h4v-3c0-2.18-3.57-3.47-6.33-3.87Z"
        clipRule="evenodd"
      />
      <path d="M9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
      <path
        fillRule="evenodd"
        d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4c-.47 0-.91.1-1.33.24a5.98 5.98 0 0 1 0 7.52c.42.14.86.24 1.33.24ZM9 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="people_alt_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPeopleAlt;
